<div class="dialog-header">
  <div class="header-title"><span class="title-span">{{header}} - {{project.name}}</span></div>

  <button mat-button [tabindex]="-1" class="close-button-container" mat-dialog-close disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="camera-block" *ngIf="showBarcodeScanner">
  <app-barcode-scanner [activityString]="activityString" (successScan)="successScan($event)"></app-barcode-scanner>
</div>

<div class="split-middle-content">
  <div class="left-block" *ngIf="!isMobile">
    <lib-progress-spinner *ngIf="showLoadingSpinner"></lib-progress-spinner>

    <ng-container *ngIf="!showLoadingSpinner && !selectedCart">
      <ng-container *ngIf="foundedDrawing">
        <ngx-extended-pdf-viewer [src]="blobUrl" [enablePinchOnMobile]="true" [zoom]="'page-width'"
                                 [showHandToolButton]="true" [showBookmarkButton]="false" [minZoom]="0.8"
                                 [showOpenFileButton]="false" [(page)]="pageToShow">
        </ngx-extended-pdf-viewer>

      </ng-container>
      <div class="no-drawing-block" *ngIf="!foundedDrawing">
        Drawing not found
      </div>
    </ng-container>

    <ng-container *ngIf="!showLoadingSpinner && selectedCart">
      <div class="cart-view">
        <app-cart-view [cart]="selectedCartToShow" [fromAssembyView]="true"></app-cart-view>
      </div>
    </ng-container>
  </div>

  <div class="right-block">
    <p-confirmDialog appendTo="body" icon="pi pi-list" styleClass="cabinets-panel">
    </p-confirmDialog>

    <div class="tool-bar" [ngClass]="{'status-ready': activityStatus.ready}">
      <button mat-button [tabindex]="-1" class="toggle-activity-button" (click)="toggleActivityReady()">
        {{header}}
        <mat-icon>done</mat-icon>
      </button>

      <div style="flex: 1; height: 2.5em; display: flex; align-items: center;">
        <p-dropdown *ngIf="project.carts && !isMobile" [options]="project.carts" [(ngModel)]="selectedCart"
                    [tabindex]="-1"
                    optionLabel="number"
                    (onChange)="cartChanged()"
                    placeholder="Carts"
                    styleClass="carts-dropdown">
          <ng-template pTemplate="selectedItem">
            <div>Cart #{{selectedCart?.number}}</div>
          </ng-template>
          <ng-template let-cart pTemplate="item">
            <div>Cart #{{cart.number}}</div>
          </ng-template>
        </p-dropdown>
      </div>

      <button mat-button [tabindex]="-1" class="toggle-drawing-button" (click)="toggleDrawing()"
              [ngClass]="{'toggled-button': !showDrawing}">
        Drawing
      </button>

      <button mat-button [tabindex]="-1" class="labels-print-button" (click)="printLabels()"
              [ngClass]="{'scanning': scanLoading, 'disabled-icon': !cabinets?.length || showParts}"
              [disabled]="!cabinets?.length || showParts">
        <div class="scan-wrapper-block">
          <mat-icon *ngIf="!scanLoading">print</mat-icon>
          <lib-mini-progress-spinner *ngIf="scanLoading"></lib-mini-progress-spinner>
        </div>
      </button>

      <button mat-button [tabindex]="-1" class="labels-print-button" (click)="toggleCamera()"
              *ngIf="!isDesktop && !showParts">
        <div class="scan-wrapper-block">
          <mat-icon matRipple>center_focus_weak</mat-icon>
        </div>
      </button>
        <button mat-button [tabindex]="-1" class="labels-print-button hidden-cabinets-button"
                (click)="openHiddenCabinetsDialog()"
                *ngIf="hidingMode && !showParts">
            Hidden cabinets
        </button>
        <button mat-button [tabindex]="-1" class="labels-print-button toggle-hiding-mode-button" (click)="toggleHidingMode()"
                [ngClass]="{'toggled-button': hidingMode}">
            <div class="scan-wrapper-block">
                <mat-icon matRipple>{{hidingMode ? 'visibility' : 'visibility_off'}}</mat-icon>
            </div>
        </button>


    </div>

    <div class="cabinets-middle-content" [ngClass]="{'barcode-enabled': showBarcodeScanner}">

      <div class="history-loading-screen" *ngIf="cabinetsIsLoading" style="width: 100%; height: 20em;">
        <lib-progress-spinner></lib-progress-spinner>
      </div>
      <div *ngIf="cabinets?.length === 0 && partGroups?.length > 0" class="no-history">
        <ng-container *ngIf="!showParts">No Cabinets</ng-container>
        <ng-container *ngIf="showParts">No Parts</ng-container>
      </div>

      <div class="cabinet-blocks" *ngIf="!cabinetsIsLoading && (cabinets?.length > 0 || partGroups?.length > 0)">
        <app-finishing-parts *ngIf="showParts" [project]="project" [partGroups]="partGroups"
                             [booleanString]="booleanString"
                             [isMobile]="isMobile"
                             (scrollToFileEmitter)="scrollToFile($event)"
                             (toggleCabinetStatusEmitter)="toggleCabinetStatus($event)"
                             (deleteItemEmitter)="deleteCabinet($event)"></app-finishing-parts>

        <app-cabinet-list *ngIf="!showParts" [project]="project" [cabinets]="cabinets" [booleanString]="booleanString"
                          [isMobile]="isMobile"
                          [hidingMode]="hidingMode"
                          [clearHideConfirmations]="clearHideConfirmations"
                          (scrollToFileEmitter)="scrollToFile($event)"
                          (toggleCabinetStatusEmitter)="toggleCabinetStatus($event)"
                          (deleteItemEmitter)="deleteCabinet($event)"
                          (hideCabinetEmitter)="hideCabinet($event)"></app-cabinet-list>

        <div class="cabinets-footer" *ngIf="!cabinetsIsLoading">
          <div class="field-for-new-cabinet" *ngIf="showAddInput">
            <div class="close-block" (click)="closeInput()">
              <mat-icon>clear</mat-icon>
            </div>
            <div class="upper-input cabinet-input" *ngIf="!showParts">
              <input class="cab-input-field" type="text" pInputText BlockLateralArrowNavigation placeholder="Name"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="newCabinetName">
            </div>
            <div class="cabinet-input">
              <input class="cab-input-field" type="text" pInputText BlockLateralArrowNavigation
                     placeholder="Description"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="newCabinetDesc">
            </div>

            <button *ngIf="showParts" mat-button class="save-cabinet-button add-line-button" (click)="createCabinet()"
                    [ngClass]="{'disabled-button': !newCabinetDesc || newCabLoading}"
                    [disabled]="!newCabinetDesc || newCabLoading">
              <div class="button-title">
                <span *ngIf="!newCabLoading">Save</span>
                <lib-mini-progress-spinner *ngIf="newCabLoading"></lib-mini-progress-spinner>
              </div>
            </button>

            <button *ngIf="!showParts" mat-button class="save-cabinet-button add-line-button" (click)="createCabinet()"
                    [ngClass]="{'disabled-button': !newCabinetName || newCabLoading}"
                    [disabled]="!newCabinetName || newCabLoading">
              <div class="button-title">
                <span *ngIf="!newCabLoading">Save</span>
                <lib-mini-progress-spinner *ngIf="newCabLoading"></lib-mini-progress-spinner>
              </div>
            </button>

          </div>

          <div class="additional-block-for-cabinets" *ngIf="cabinets?.length > 0 || partGroups?.length > 0">
            <button mat-button [tabindex]="-1" class="add-cabinet-button add-line-button" (click)="addCabinet()"
                    *ngIf="!showAddInput">
              <mat-icon>add</mat-icon>
              <div class="button-title">New Item</div>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
